// 统一使用环境变量配置API地址
export const base = process.env.VUE_APP_BASE_API;
export const uploadUrl = base + "/upload/file";
export const uploadPicUrl = base + "/upload/oss_file";
export const uploadVideoUrl =  base + '/app/upload/chunk';
export const progressUrl =  base + '/app/upload/chunk/progress';
export const compressVideoUrl =  base + '/app/upload/compress';
export const comSaskStatus =  base + '/app/upload/task/status';
export const ossUploadUrl =  base + '/app/upload/oss';